<template>
  <div>
    <Simulation
      :simulationDevices="simulationDevices"
      :busConfigurations="busConfigurations"
      simulationLabel="ResolFwr_1d00_p40 2er Kaskade"
    >
    </Simulation>
  </div>
</template>

<script>
import Simulation from '@/components/Simulation';
import ResolFwr_1d00_p40 from '@/device-products/ResolFwr_1d00_p40.vue';

export default {
  components: {
    Simulation,
  },

  data: () => ({
    busConfigurations: [
    ],
    simulationDevices: [
      { id: 0, component: ResolFwr_1d00_p40, deviceLabel: 'Codierung 0: ALL', props: { leiterplattenCodierung: 0 } }, // swapped after FWR2018
      { id: 1, component: ResolFwr_1d00_p40, deviceLabel: 'Codierung 1: FREQUENCY', props: { leiterplattenCodierung: 1 } },
    ],
  }),
};
</script>

<style>

</style>
